import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import {
  RemoteConfigService,
  UNDER_CONSTRUCTION_CONFIG_KEY,
} from '../services/remote-config.service';

const isUnderConstruction = async (): Promise<boolean> => {
  const remoteConfig = inject(RemoteConfigService);
  return (
    (await remoteConfig.getRemoteConfigBoolean(
      UNDER_CONSTRUCTION_CONFIG_KEY,
      environment.underConstruction,
    )) === true
  );
};

export const siteStatusGuard: CanActivateFn = async () => {
  const router = inject(Router);

  if (await isUnderConstruction()) {
    return router.createUrlTree(['/under-construction']);
  }

  return true;
};

export const siteStatusChildGuard: CanActivateChildFn = siteStatusGuard;

export const constructionPageGuard: CanActivateFn = async () => {
  const router = inject(Router);

  if (await isUnderConstruction()) {
    return true;
  }

  return router.createUrlTree(['/']);
};

export const comingSoonAuthGuard: CanActivateFn = () => {
  const router = inject(Router);

  return environment.comingSoon ? router.createUrlTree(['/']) : true;
};
